module.exports = __webpack_public_path__ + "azure-web-app.f544a511ef1afb239b5f2248b6ae17c4.hashedasset.svg";